import axios from 'axios';
import { isNotEmpty } from '../utils/Validator.js';
import {config} from "./ConfigService";
import Cookies from 'js-cookie';
import heapAnalytics from "./HeapAnalyticsService";
///wcp-portal-services-1 

export const USER_NAME_SESSION_ATTRIBUTE_NAME = 'authenticatedUserNm'
export const TOKEN_SESSION_ATTRIBUTE_NAME = 'authenticatedUserToken'
export const USER_SESSION_ATTRIBUTE_NAME = 'authenticatedUser'

const MIRROR_USER_NAME_SESSION_ATTRIBUTE_NAME = 'mirrorUserNm'
const MIRROR_USER_SESSION_ATTRIBUTE_NAME = 'mirrorUser'

const INITIAL_URL_SESSION_ATTRIBUTE_NAME = 'initialUrl'

class AuthenticationService {
    axiosInterceptor = null;

    getCancelTokenSource() {
        return axios.CancelToken.source();
    }

    isCancelRequest(error) {
        return axios.isCancel(error);
    }

    executeJwtAuthenticationService(username, password) {
        return axios.post(`${config.API_URL}/authenticate`, {
            username,
            password
        })
    }

    changeUsrPwd(username, password, newPassword) {
		return axios.post(`${config.API_URL}/users/updatePwd`, {
            username,
            password,
            newPassword
        })
    }
    // called when the uer logs in
    reregisterLoginUser() {          
        var userItem = sessionStorage.getItem(USER_SESSION_ATTRIBUTE_NAME);
        var token = sessionStorage.getItem(TOKEN_SESSION_ATTRIBUTE_NAME);
        if ( userItem ) { 
            var user = JSON.parse(userItem);
            this.registerSuccessfulLoginForJwt(user.userNm, token);
            this.setUserDetails(user);
            return user;            
        } else {
            return null;
        }    
    }

    registerSuccessfulLoginForJwt(userNm, token) {                     
        sessionStorage.setItem(TOKEN_SESSION_ATTRIBUTE_NAME, token);
        sessionStorage.setItem(USER_NAME_SESSION_ATTRIBUTE_NAME, userNm);
        this.setupAxiosInterceptors(this.createJWTToken(token));      
        this.removeMirrorUser();  
    }

    setUserDetails(user) {                
        sessionStorage.setItem(USER_SESSION_ATTRIBUTE_NAME, JSON.stringify(user));
        sessionStorage.setItem(USER_NAME_SESSION_ATTRIBUTE_NAME, user.userNm);
        
        let analyticsUser = {};
        analyticsUser.id = user.id;
        analyticsUser.role =
          user.typeCd === "PRUS" ? "Sub User" : "Admin User";
        window.analytics.user = { ...analyticsUser, ...user };        

        // The user-details API returns the WCP user-info identifier as `id`.
        // Use it for Heap identity instead of the mutable login username.
        if (user.id != null) {
            heapAnalytics.identifyUser(String(user.id), {
                userInfoId: user.id,
                role: analyticsUser.role,
                typeCd: user.typeCd,
                affiliationCd: user.affiliationCd,
                applicationName: heapAnalytics.applicationName,
                environment: heapAnalytics.environment,
            });
        }
    }
    
    setMirrorUser(mirrorUsrNm, mirrorUsr) {
        sessionStorage.setItem(MIRROR_USER_NAME_SESSION_ATTRIBUTE_NAME, mirrorUsrNm);
        sessionStorage.setItem(MIRROR_USER_SESSION_ATTRIBUTE_NAME, mirrorUsr);
       // axios.post(`${config.API_URL}/logger/log/User ${loggedNm} is ${mirrorNm}`, null, null);
    }

    removeMirrorUser(mirrorNm, loggedNm) {
        sessionStorage.removeItem(MIRROR_USER_NAME_SESSION_ATTRIBUTE_NAME);
        sessionStorage.removeItem(MIRROR_USER_SESSION_ATTRIBUTE_NAME);
        if(mirrorNm !== '') {
           // axios.post(`${config.API_URL}/logger/log/User ${loggedNm} has stopped ${mirrorNm}`, null, null);
        }
    }

    getToken() {
        return sessionStorage.getItem(TOKEN_SESSION_ATTRIBUTE_NAME);
    }

    getInitialUrl() {
        return sessionStorage.getItem(INITIAL_URL_SESSION_ATTRIBUTE_NAME);
    }

    popInitialUrl() {
        let url = sessionStorage.getItem(INITIAL_URL_SESSION_ATTRIBUTE_NAME);
        sessionStorage.removeItem(INITIAL_URL_SESSION_ATTRIBUTE_NAME);
        return url;
    }

    setInitialUrl(url) {
        return sessionStorage.setItem(INITIAL_URL_SESSION_ATTRIBUTE_NAME, url);
    }

    clearInitialUrl() {
        return sessionStorage.removeItem(INITIAL_URL_SESSION_ATTRIBUTE_NAME);
    }

    getMirrorUser() {
        let user = sessionStorage.getItem(MIRROR_USER_NAME_SESSION_ATTRIBUTE_NAME)
        if (user === null) return ''
        return user
    }

    getMirrorUserInfo() {
        let user = sessionStorage.getItem(MIRROR_USER_SESSION_ATTRIBUTE_NAME)
        if (user === null) return null
        return user
    }

    logMessage(msg) {
        //axios.post(`${config.API_URL}/logger/log/${msg}`, null, null);
    }

    createJWTToken(token) {
        return 'Bearer ' + token;
    }

    getApiUrl() {
        return config.API_URL;
    }

    logout() {        
        sessionStorage.removeItem(USER_SESSION_ATTRIBUTE_NAME);
        sessionStorage.removeItem(TOKEN_SESSION_ATTRIBUTE_NAME);
        sessionStorage.removeItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
        this.removeMirrorUser();
        this.clearInitialUrl();
        heapAnalytics.resetIdentity();

        if (this.axiosInterceptor !== null) {
            axios.interceptors.request.eject(this.axiosInterceptor);
            this.axiosInterceptor = null;
        }
    }

    isUserLoggedIn() {        
        let user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME)
        if (user === null) return false
        return true
    }

    setLoggedInUserName(userNm) {
        sessionStorage.setItem(USER_NAME_SESSION_ATTRIBUTE_NAME, userNm)        
    }

    getLoggedInUserName() {
        let user = sessionStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME)
        if (user === null) return ''
        return user
    }

    getProvidersState(prvId,prvType,taxId) {
        if (prvType === "P") {
            return axios.get(`${config.API_URL}/clients/states/${prvType}/${prvId}/?prvTin=${taxId}`)
        } else {
            return axios.get(`${config.API_URL}/clients/states/${prvType}/${prvId}/`)
        }
    }

    getProviders(taxId) {
        return axios.get(`${config.API_URL}/clients/list/${taxId}`)
    }

    getProducts(lob, cpdProvId, cpdProvStateCd, cpdProvTin) {
        return axios.get(`${config.API_URL}/clients/getProductsByProv/${lob}/${cpdProvId}/${cpdProvStateCd}/${cpdProvTin}/`)
    }

    getClntDtls(aeId, aeNm) {
        return axios.get(`${config.API_URL}/clients/getClientDetails/${aeId}/${aeNm}/`)
    }

    getClients(lob, provId, provState, prod, provTin) {
        return axios.get(`${config.API_URL}/clients/getClientsByLOB/${lob}/${provId}/${provState}/${prod}/${provTin}/`)
    }

    getUserFtins(username) {
        let ftinUser = username;
        let mUser = this.getMirrorUser();
        if(isNotEmpty(mUser)) {
            ftinUser = mUser;
        }
        return axios.get(`${config.API_URL}/ftin/userFtins/${ftinUser}?activeFlag=true`)
    }

    getUsrDtls(username) {
        return  axios.get(`${config.API_URL}/users/userByName/${username}`)
    }
    updateUsrDtls(userDtlsInfo){
        return axios.put(`${config.API_URL}/users/updateUser`, userDtlsInfo)
     }

    getSecQuestionsForUserProfile() {
        return axios.get(`${config.API_URL}/appProperties/secQuestions`)
    }

    //manage Tin ftin/userFtins/{userName}?activeFlag=true
    getFtinsForUser(grpId) {
        return axios.get(`${config.API_URL}/ftin/groupFtins/${grpId}?activeFlag=true`)
    }

    validateFtinForUser(ftin,  bcn, cpdId) {
        if (isNotEmpty(bcn)) {
            return axios.get(`${config.API_URL}/ftin/validateFtin/${ftin}/?bcn=${bcn}`)
        } else {
            return axios.get(`${config.API_URL}/ftin/validateFtin/${ftin}/?cpdId=${cpdId}`)
        }
    }

    addUserFtin(userName, ftin,  bcn, cpdId) {
    return axios.post(`${config.API_URL}/ftin/validateandSaveFtin/${ftin}/${userName}`,null, {params :{
       cpdId,
        bcn
    }})
}
    deleteFtin(grpId, ftin, lastUpdatedUserName) {
        return axios.delete(`${config.API_URL}/ftin/groupFtins/${grpId}/${ftin}?lastUpdatedUserName=${lastUpdatedUserName}`)
    }

    postFtin(grpId, ftin, cpdId, bcn, userName) {
        console.log(`post ftin ->${ftin}`)

         return axios.post(`${config.API_URL}/ftin/groupFtins/${grpId}/${ftin}`, {
            grpId:grpId,ftin:ftin,cpdId:cpdId,billCntrlNum:bcn,createdDate:null,inactiveDate:null,lastUpdatedUserName:userName
        } )
    }

    postFtinForNNUS(grpId, ftin, userName) {
        console.log(`post ftin for nnus ->${ftin}`)

         return axios.post(`${config.API_URL}/ftin/nonNetworkGroupFtins/${grpId}/${ftin}`, {
            grpId:grpId,ftin:ftin,createdDate:null,inactiveDate:null,lastUpdatedUserName:userName
        } )
    }
    postFtinForForceAddNNUS(grpId, ftin, userName) {
        console.log(`post ftin for force add nnus ->${ftin}`)

         return axios.post(`${config.API_URL}/ftin/nonNetworkGroupFtinsForceAdd/${grpId}/${ftin}`, {
            grpId:grpId,ftin:ftin,createdDate:null,inactiveDate:null,lastUpdatedUserName:userName
        } )
    }

     //manage user ftins for users
    getFtinsForManageUser( userName) {
        return axios.get(`${config.API_URL}/ftin/managedUserFtins/${userName}`)
    }
    //manage user ftins for users by UserId
    getFtinsForManageUserId( userId) {
        return axios.get(`${config.API_URL}/ftin/managedUserFtins/byUserId/${userId}`)
    }
    postFtinsForManageUser( userName, ftins) {
        return axios.post(`${config.API_URL}/ftin/managedUserFtins/${userName}?lastUpdatedUserName=${userName}`, ftins )
    }

    validateNonNetworkFTIN(ftin){
          return axios.get(`${config.API_URL}/ftin/validateNonNetworkFtin/${ftin}`)
    }
    
    validateInNetworkFTIN(ftin){
          return axios.get(`${config.API_URL}/ftin/validateInNetworkFtin/${ftin}`)
    }

    // Get source IDs for roster management
    getSourceIdsForUser(grpId) {
        return axios.get(`${config.API_URL}/roster/source/group/${grpId}`)
    }
    
    // Get roster source groups for a group
    getRosterSourceGroupsForUser(grpId) {
        return axios.get(`${config.API_URL}/roster/sourceGroup/${grpId}`)
    }
    // Get all roster source groups for a group
    getAllRosterSourceGroups() {
        return axios.get(`${config.API_URL}/roster/sourceGroups`)
    }
    // Get all roster source
    getAllRosterSources() {
        return axios.get(`${config.API_URL}/roster/sources`)
    }  
    // Get roster upload logs for a group
    getRosterUploadLogs(grpId) {
        return axios.get(`${config.API_URL}/roster/uploadLogs/group/${grpId}`)
    }
    
    // Upload roster files - Updated for new API that accepts MultiValueMap<String, MultipartFile>
    uploadRosterFiles(sourceId, groupName, groupId, filesGroupedByType) {
        const formData = new FormData();
        formData.append("sourceId", sourceId);
        formData.append("groupName", groupName);
        formData.append("groupId", groupId);
        
        // filesGroupedByType is an object like: { full: [File, File], delta: [File] }
        // For @RequestParam MultiValueMap<String, MultipartFile> rosterFiles
        // Send files directly with roster type as the parameter name
        // Spring will automatically group files with the same parameter name into the MultiValueMap
        Object.keys(filesGroupedByType).forEach(rosterType => {
            const filesForType = filesGroupedByType[rosterType];
            filesForType.forEach(file => {
                // Append files with roster type as the parameter name
                // Multiple files with same key will be collected in the MultiValueMap
                formData.append(rosterType, file);
            });
        });
        
        return axios.post(`${config.API_URL}/roster/upload`, formData);
    }

    addSourceToGroup(groupId, sourceId) {
        return axios.post(`${config.API_URL}/roster/user/group/addSource`,null, {params :{
            "groupId": groupId,
            "sourceId": sourceId
        }});
    }

    removeSourceFromGroup(groupId, sourceId) {
        return axios.post(`${config.API_URL}/roster/user/group/removeSource`,null, {params :{
            "groupId": groupId,
            "sourceId": sourceId
        }});
    }

    //manage users /users/manageUsers/{grpId}/{username}
    getManageUsersUsers(grpId, username) {        
        return axios.get(`${config.API_URL}/users/manageUsers/${grpId}/${username}`)
    }

    convertUserToAdmin(adminUser, userName){
        return axios.post(`${config.API_URL}/users/convertUserToAdmin/${adminUser}/${userName}`)
    }
    
    convertAdminToUser(adminUser, userName){
        return axios.post(`${config.API_URL}/users/convertAdminToUser/${adminUser}/${userName}`)
    }

    resetPassword(userName, emailAddress,adminUserName){
        
        return axios.post(`${config.API_URL}/users/resetPasswordByAdmin/start`, {
            userName:userName,
            emailAddress:emailAddress,
            adminUserName: adminUserName
        } )
    }

    terminate(userDtl) {
        return axios.put(`${config.API_URL}/users/terminate`, userDtl)
    }

    terminateUser(adminUser,userName) {
            return axios.put(`${config.API_URL}/users/terminateUser/${adminUser}/${userName}`)
    } 

    forgotUsername(emailAddress) {
        return axios.post(`${config.API_URL}/public/forgotUsername`,emailAddress)
    }
    checkEmailAddressExists(emailAddress) {
        return axios.post(`${config.API_URL}/users/checkEmailAddressExists/${emailAddress}`)
    }
    getUserAccountTypes() {
        return axios.put(`${config.API_URL}/users/getUserTypes`)
    }
    createNewUser(UserDetailsInfo){
        return axios.put(`${config.API_URL}/users/createUser`, UserDetailsInfo)
    }
    saveDraftUser(UserDetailsInfo){
        return axios.put(`${config.API_URL}/users/saveDraftUser`, UserDetailsInfo)
    }
    resendRegistration(adminUserNm, newUserId){
        return axios.post(`${config.API_URL}/users/regenRegistrationByAdmin/${adminUserNm}/${newUserId}`)
    }

    getProviderResources() {
        //return axios.get(`${config.API_URL}/public/providerResources`)
        return axios.get(`${config.RESOURCE_URL}/api/assets/wcpp/provider-resources/provider-resources.json`)
    }

    getBaseUrl() {
        return config.RESOURCE_URL;
    }

    getAuthHeader() {
        const token = Cookies.get("authorization");
        //console.log(`Cookies authorization : ${token}`)
        return { 'Authorization': `Bearer ${token}` };
    }

    getIdleTimeout() {
        return axios.get(`${config.API_URL}/appProperties/property/FE_APP_TIMEOUT`)
    }
    getNotifications = () => {
        return axios.get(`${config.API_URL}/notifications/list`);
    }
    searchUser(userName, emailAddress,tin, userTypeCD, groupId, userIDs,status, isUserNames){
        return axios.post(`${config.API_URL}/admin/userList`, {
            userTypeCD:userTypeCD,
            userName:userName,
            emailAddress:emailAddress,
            ftin: tin,
            groupId: groupId,
            userIDs: userIDs,
            status: status,
            isUserNames:isUserNames
        } )
    }

    searchGroup(portalUserGroupId, taxIdNumber, rosterHubSource, providerHubGroupId, username, emailAddress){
        return axios.post(`${config.API_URL}/admin/groupList`, {
            portalUserGroupId:portalUserGroupId,
            taxIdNumber:taxIdNumber,
            rosterHubSource:rosterHubSource,
            providerHubGroupId: providerHubGroupId,
            username: username,
            emailAddress: emailAddress
        } );
    }

    searchProviders(payload, cancelToken) {
        return axios.post(`${config.API_URL}/provider/list`, payload, {
            cancelToken
        });
    }

    // this is only called during login
    setupAxiosInterceptors(token) {
        // remove the interceptor which contains an old token if it is present
        if (this.axiosInterceptor !== null) {
            axios.interceptors.request.eject(this.axiosInterceptor);
            this.axiosInterceptor = null;
        }

        this.axiosInterceptor = axios.interceptors.request.use(
            (config) => {
                if ( this.isUserLoggedIn()) {
                    config.headers.authorization = token;                                                                        
                }
                return config
            }
        )

        axios.interceptors.response.use(response => {
                return response;
            }, error => {
                if (error.response?.status === 401 && error.response?.config?.url?.includes("/wcpp-services/")) {
                   this.logout();
                   window.location.href = "/wcpp/login";                
                }
                return error;
            });
    }
}

export default new AuthenticationService()
